import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { placeSetSchema } from '../schemas/place-set.schema';

/**
 * Requests a specific Place Set
 * @param setId The set ID of the Place Set being requested
 * @returns The Place Set
 */
export function getPlaceSetsId(this: unknown, setId: number) {
  const requestUrl = `${fleetEnvironment.resolve(this).placeSetsUrl}/${setId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(placeSetSchema));
}
